export type CrosshairState = "default" | "shieldActive" | "cooldown" | "targeted";

export class Crosshair {
  private el: HTMLElement;

  constructor(host: HTMLElement) {
    this.el = document.createElement("div");
    this.el.id = "hud-crosshair";
    host.appendChild(this.el);
    this.setState("default");
  }

  setState(state: CrosshairState) {
    this.el.className = state;
  }

  setVisible(v: boolean) {
    this.el.style.display = v ? "block" : "none";
  }
}
